import { createReducer, on } from '@ngrx/store';

import { DeviceModel } from '@services/device_models.service';
import { storeDeviceModels } from '@store/deviceModels/device_models.actions';

export interface DeviceModelsState {
  list: DeviceModel[];
}

export const initialState: DeviceModelsState = {
  list: [],
};

export const deviceModelsReducer = createReducer(
  initialState,
  on(storeDeviceModels, (state, { list }) => ({ ...state, list })),
);
